/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useState, useEffect} from "react";


import {Col, Form, Row} from "react-bootstrap";


import VEHICLE_INTERFACE from "@Services/Application/Interfaces/Vehicles/Vehicle";


type VehiclesActiveSetProps = {
    FAVORITE_VEHICLES: VEHICLE_INTERFACE[];
    ACTIVE_VEHICLE_STATUS_HANDLER(VEHICLE: VEHICLE_INTERFACE | null, ACTION: "ON" | "OFF", TRIGGER: "ON" | "OFF", TOKEN?: any): void;
};


export const VehiclesActiveSetComponent: React.FC<VehiclesActiveSetProps> = ({
    FAVORITE_VEHICLES, ACTIVE_VEHICLE_STATUS_HANDLER
}): JSX.Element | null => {


    const FRONT_FAVORITE_VEHICLES = FAVORITE_VEHICLES.filter((VEHICLE) => !!VEHICLE.IsFront);
    const REAR_FAVORITE_VEHICLES = FAVORITE_VEHICLES.filter((VEHICLE) => !VEHICLE.IsFront);

    const ACTIVE_FRONT_VEHICLE = FAVORITE_VEHICLES.filter((VEHICLE) => !!VEHICLE.IsFront && !!VEHICLE.Active)[0];
    const ACTIVE_REAR_VEHICLE = FAVORITE_VEHICLES.filter((VEHICLE) => !VEHICLE.IsFront && !!VEHICLE.Active)[0];

    const [SELECTED_ACTIVE_FRONT_VEHICLE, SET_SELECTED_ACTIVE_FRONT_VEHICLE] = useState<VEHICLE_INTERFACE | null>(ACTIVE_FRONT_VEHICLE || null);
    const [SELECTED_ACTIVE_REAR_VEHICLE, SET_SELECTED_ACTIVE_REAR_VEHICLE] = useState<VEHICLE_INTERFACE | null>(ACTIVE_REAR_VEHICLE || null);

    const FAVORITE_VEHICLES_LIST = Object.fromEntries(FAVORITE_VEHICLES.map(
        (VEHICLE: VEHICLE_INTERFACE) => [VEHICLE.RegNo, VEHICLE]
    ));

    const CHANGE_ACTIVE_VEHICLE = async (e: React.ChangeEvent<HTMLInputElement>, vehicleType: "F" | "R") => {

        const vehicleRegNo = e.target.value;

        let ACTIVE_VEHICLE = null;

        if (vehicleType === "F") ACTIVE_VEHICLE = ACTIVE_FRONT_VEHICLE;
        if (vehicleType === "R") ACTIVE_VEHICLE = ACTIVE_REAR_VEHICLE;

        const VEHICLE = FAVORITE_VEHICLES_LIST[vehicleRegNo];

        let TOKEN = null;

        if (!vehicleRegNo || !!ACTIVE_VEHICLE) {
            const TRIGGER = !((vehicleType === "F" && FRONT_FAVORITE_VEHICLES.length > 1) || (vehicleType === "R" && REAR_FAVORITE_VEHICLES.length > 1));
            TOKEN = await ACTIVE_VEHICLE_STATUS_HANDLER(ACTIVE_VEHICLE, "OFF", TRIGGER ? "ON" : "OFF");
        }

        await ACTIVE_VEHICLE_STATUS_HANDLER(VEHICLE, "ON", "OFF", TOKEN);

        if (vehicleType === "F") SET_SELECTED_ACTIVE_FRONT_VEHICLE(VEHICLE || null)
        if (vehicleType === "R") SET_SELECTED_ACTIVE_REAR_VEHICLE(VEHICLE || null)

    };

    useEffect(() => {
        SET_SELECTED_ACTIVE_FRONT_VEHICLE(ACTIVE_FRONT_VEHICLE || null);
    }, [ACTIVE_FRONT_VEHICLE]);

    useEffect(() => {
        SET_SELECTED_ACTIVE_REAR_VEHICLE(ACTIVE_REAR_VEHICLE || null);
    }, [ACTIVE_REAR_VEHICLE]);

    const FrontVehiclesList = FRONT_FAVORITE_VEHICLES.map((VEHICLE, i: number) =>
        <option key={i} value={VEHICLE?.RegNo}>{VEHICLE?.RegNo}</option>
    );

    const RearVehiclesList = REAR_FAVORITE_VEHICLES.map((VEHICLE, i: number) =>
        <option key={i} value={VEHICLE?.RegNo}>{VEHICLE?.RegNo}</option>
    );

    return (
        <Col xs={12} className={"active-vehicles-set-component active-vehicles-set"}>
            <Row className={"active-vehicles-set-content"}>

                <Col xs={12} className={"default-section-header"}>
                    <span>{`Aktywny zestaw pojazdów`}</span>
                </Col>

                <Col xs={12} className={"active-vehicles-switcher-component active-vehicles-switcher"}>
                    <Row className={"active-vehicles-switcher-content"}>

                        <Col xs={6} className={""}>
                            <Form.Label>{`Pojazd przedni`}</Form.Label>
                            <Form.Control
                                as={"select"}
                                disabled={!(FRONT_FAVORITE_VEHICLES.length > 0)}
                                value={SELECTED_ACTIVE_FRONT_VEHICLE?.RegNo || ""}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => CHANGE_ACTIVE_VEHICLE(e, "F")}
                            >
                                <option value={""}>{`brak`}</option>
                                {FrontVehiclesList}
                            </Form.Control>
                        </Col>

                        <Col xs={6} className={""}>
                            <Form.Label>{`Pojazd tylny`}</Form.Label>
                            <Form.Control
                                as={"select"}
                                disabled={!(REAR_FAVORITE_VEHICLES.length > 0)}
                                value={SELECTED_ACTIVE_REAR_VEHICLE?.RegNo || ""}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => CHANGE_ACTIVE_VEHICLE(e, "R")}
                            >
                                <option value={""}>{`brak`}</option>
                                {RearVehiclesList}
                            </Form.Control>
                        </Col>

                    </Row>
                </Col>

            </Row>
        </Col>
    );

};


export default VehiclesActiveSetComponent;
